import { SaveButton } from "components/Buttons"
import React from "react"
import { Col, ListGroup, ListGroupItem, Row } from "reactstrap"
import { TIME_FORMATS } from "constants/index"
import moment from "moment"
import ModalComponent from "components/Modals"

const AnswersModal = ({
  formBuilder,
  individualAnswersModalIsOpen,
  handleClose,
  individualAnswer,
  handleOpenRefundModal,
}) => {
  return (
    <ModalComponent
      title={formBuilder?.name}
      open={individualAnswersModalIsOpen}
      onClose={handleClose}
      size="xl"
      scrollable
    >
      <React.Fragment>
        <span>
          Viewing submission from <b>{individualAnswer?.name}</b> on{" "}
          <b>
            {moment(individualAnswer?.created_at?.date).format(
              TIME_FORMATS(
                moment().diff(
                  moment(individualAnswer?.created_at?.date),
                  "days"
                )
              ).DATETIME
            )}
          </b>
        </span>
        <ListGroup className="my-3">
          <ListGroupItem>
            <Row>
              <Col xs="4">
                <b>Question</b>
              </Col>
              <Col className="text-center">
                <b>Answer</b>
              </Col>
            </Row>
          </ListGroupItem>
          {individualAnswer?.replies?.map(item => (
            <ListGroupItem key={item?.id}>
              <Row>
                <Col xs="4">{item?.question?.question}</Col>

                <Col className="d-flex flex-wrap justify-content-center">
                  {item?.has_files
                    ? item?.files?.map(file =>
                        file?.type === "image" ? (
                          <img
                            src={file?.url || ""}
                            className="rounded avatar-xl"
                            style={{ blockSize: "auto", margin: "5px" }}
                          />
                        ) : (
                          <video
                            className="rounded avatar-xl"
                            style={{ blockSize: "auto", margin: "3px" }}
                            controls
                            src={file?.url || ""}
                          ></video>
                        )
                      )
                    : !!item?.answer
                    ? item?.answer?.answer
                    : item?.answer_text}
                </Col>
              </Row>
            </ListGroupItem>
          ))}
        </ListGroup>
        <Row>
          <Col>
            <h5>Payment Details</h5>
          </Col>
        </Row>
        {!individualAnswer?.stripe_payment ? (
          <Row>
            <Col>
              <span>Free</span>
            </Col>
          </Row>
        ) : (
          <>
            {individualAnswer?.stripe_payment?.connected_account_changed &&
              !!individualAnswer?.stripe_payment &&
              ((!!individualAnswer?.stripe_payment?.refunded_amount &&
                individualAnswer?.stripe_payment?.partial_refund) ||
                !individualAnswer.stripe_payment.refunded_amount) && (
                <p>
                  !!! A refund can not be done from the dashboard because the
                  connected account has been changed.
                  <br />
                  You can do the refund only from the stripe account(id:{" "}
                  <b>
                    {individualAnswer?.stripe_payment?.connected_account_id}
                  </b>
                  ), where the payment was done.
                </p>
              )}
            {!!individualAnswer?.stripe_payment &&
              !!individualAnswer?.stripe_payment?.refunded_amount && (
                <b>
                  {individualAnswer?.stripe_payment?.partial_refund && (
                    <span>PARTIAL </span>
                  )}
                  <span>REFUNDED </span>
                  {individualAnswer?.stripe_payment?.partial_refund && (
                    <span>
                      ($
                      {individualAnswer?.stripe_payment?.refunded_amount / 100})
                    </span>
                  )}
                </b>
              )}
            {!!individualAnswer?.stripe_payment &&
              individualAnswer?.stripe_payment?.refund_status == 3 && (
                <span>
                  <b>REFUNDING</b>
                </span>
              )}
            <br />
            Order ID: {individualAnswer?.order_id}
            <br />
            Date Ordered:{" "}
            {moment(individualAnswer?.created_at?.date).format(
              TIME_FORMATS(
                moment().diff(
                  moment(individualAnswer?.created_at?.date),
                  "days"
                )
              ).DATETIME
            )}
            <br />
            Order Total: ${individualAnswer?.stripe_payment?.amount / 100}
            <br />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "start",
              }}
            >
              <div>Billing: </div>&nbsp;
              <div>
                <span>{individualAnswer?.stripe_payment?.billing_name}</span>
                <br />
                <span>
                  {individualAnswer?.stripe_payment?.billing_line1}{" "}
                  {individualAnswer?.stripe_payment?.billing_line2}
                </span>
                <br />
                <span>
                  {individualAnswer?.stripe_payment?.billing_city}{" "}
                  {individualAnswer?.stripe_payment?.billing_state}{" "}
                  {individualAnswer?.stripe_payment?.billing_country}
                  {individualAnswer?.stripe_payment?.postal_code}
                </span>
              </div>
            </div>
            <div>
              Payment Method:&nbsp;
              {individualAnswer?.stripe_payment?.payment_method == 1 && (
                <span>
                  *** *** *** {individualAnswer?.stripe_payment.card_last4}
                </span>
              )}
              {individualAnswer?.stripe_payment?.payment_method == 2 && (
                <span>Apple Pay</span>
              )}
              {individualAnswer?.stripe_payment?.payment_method == 3 && (
                <span>Google Pay</span>
              )}
            </div>
            <br />
            {!!individualAnswer?.stripe_payment &&
              individualAnswer?.stripe_payment?.refunded_at && (
                <p>
                  <b>
                    Refunded at:{" "}
                    <span>
                      {moment(
                        individualAnswer?.stripe_payment?.refunded_at
                      ).format(
                        TIME_FORMATS(
                          moment().diff(
                            moment(
                              individualAnswer?.stripe_payment?.refunded_at
                            ),
                            "days"
                          )
                        ).DATETIME
                      )}
                    </span>
                  </b>
                </p>
              )}
          </>
        )}
        <Row className="d-flex justify-content-center">
          <Col xs="auto">
            <SaveButton content="OK" type="button" onClick={handleClose} />
          </Col>
          {!!individualAnswer?.stripe_payment &&
            !individualAnswer?.stripe_payment?.connected_account_changed &&
            !individualAnswer?.stripe_payment?.full_refund && (
              <Col xs="auto">
                <SaveButton
                  content="Refund"
                  color="danger"
                  type="button"
                  onClick={handleOpenRefundModal}
                />
              </Col>
            )}
        </Row>
      </React.Fragment>
    </ModalComponent>
  )
}

export default AnswersModal
